module.exports = __webpack_public_path__ + "img/trip_23.fb91cd75.jpg";